import {StyledServiceOrderWorkDeliveryHeader} from "../../../../card/drawer/order-info/work-delivery/styles";
import {StyledServiceOrderListHeaderTitle} from "../../../../header/styles";

export function CustomerServiceOrderWorkDeliveryHeader() {
  return (
    <StyledServiceOrderWorkDeliveryHeader>
      <StyledServiceOrderListHeaderTitle>Work delivery</StyledServiceOrderListHeaderTitle>
    </StyledServiceOrderWorkDeliveryHeader>
  );
}
